import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Import FormsModule
import { Router } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { TIME_FORMAT_Date, commentRecord } from '../../../utils/constants';
import { confirmationMessages } from '../../../utils/popup-messages';
import { fileDirectories } from '../../../utils/view-settings';
import { AppSyncService } from '../../services/appsync/appsync.service';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';
import { ConfirmationPopupComponent } from '../../services/common/popups/confirmation-popup/confirmation-popup.component';
import { ApiCallsService } from '../../services/network/api-calls.service';
import { UserService } from '../../services/user.service';
import { ReportCommentComponent } from '../report-comment/report-comment.component';

@Component({
  selector: 'app-comment-box',
  imports: [CommonModule, FormsModule, NgbModule, InfiniteScrollModule],
  templateUrl: './comment-box.component.html',
  styleUrl: './comment-box.component.scss',
})
export class CommentBoxComponent implements OnInit {
  @Input() public DetailsFeed: any;
  @Input() public page: any;
  commentList: any = [];
  searchContent: any;
  DATE_FORMAT = TIME_FORMAT_Date;
  fileDirectoriesPath: any = fileDirectories.profile;
  userDetail: any;
  editId: any;
  EditContent: any;
  activeDropdown: number | null = null;
  @Output() commentCount = new EventEmitter<any>();
  nextToken: any = null;
  private subscription: Subscription | undefined;
  scroolInit = false;
  hitApi = false;

  @ViewChild('commentContainer') commentContainer!: ElementRef;

  @Output() closeBox = new EventEmitter<any>();
  constructor(
    private _userService: UserService,
    private ref: ChangeDetectorRef,
    private _ngbModal: NgbModal,
    private _toastr: ToastrService,
    private _commonDataService: CommonDataSharingService,
    private _appSyncService: AppSyncService,
    private _apiService: ApiCallsService,
    private _router: Router,
  ) {}
  ngOnInit(): void {
    this._userService.user.subscribe((user: any) => {
      this.userDetail = user ?? null;
    });
    if (this.DetailsFeed.id) {
      this._apiService.loader(true);
      this.loadComments();
      this.attachSubscription();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  attachSubscription() {
    this.subscription = this._appSyncService.subscribeToComments(this.DetailsFeed.id, this.userDetail?.id).subscribe({
      next: (data) => {
        if (data?.data?.commentSubscription?.comment?.postId === this.DetailsFeed.id) {
          this.loadComments();
          this.commentCount.emit(data?.data?.commentSubscription?.postCounts?.commentCount || 0);
        }
      },
    });
  }
  loadComments() {
    this._apiService.loader(true);
    this._appSyncService.getActivities(this.DetailsFeed.id, 20, this.nextToken).then((response) => {
      this.nextToken = response.data?.getComments?.nextToken ? JSON.stringify(response.data?.getComments?.nextToken) : null;
      this.commentList = response.data.getComments?.items || [];
      this._apiService.loader(false);
      // console.group(this.nextToken);
    });
  }

  editable(value: any, i: any) {
    this.activeDropdown = null;
    if (value == 1) {
      this.EditContent = this.commentList[i]?.comment;
      this.editId = this.commentList[i].commentId;
    } else if (value == 3) {
      this.updateComment(this.EditContent, this.DetailsFeed.id, this.commentList[i].commentId);
    } else {
      this.editId = '';
    }
    this.ref.detectChanges();
  }
  report(data: any) {
    this.activeDropdown = null;
    let modalRef = this._ngbModal.open(ReportCommentComponent, {
      scrollable: false,
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true,
    });
    modalRef.result.then((res: any) => {
      if (res) {
        const mutation = `mutation MyMutation {
  reportComment(commentId: \"${data.commentId}\", postId: \"${this.DetailsFeed.id}\", userId: \"${this.userDetail.id}\", reason: \"${res.reason}\")
}`;
        this._commonDataService.graphqlApiCall(mutation).then((res: any) => {
          this.nextToken = null;
          this.loadComments();
          this.searchContent = '';
          this.editId = '';
          this.EditContent = '';
          this.commentCount.emit(res.data?.addComment?.postCounts?.commentCount || 0);
          this._toastr.success('Comment reported successfully');
        });
      }
    });
  }
  submitComment() {
    if (this.hitApi == false) {
      this._apiService.loader(true);
      this.hitApi = true;
      this.addComment(this.searchContent, this.DetailsFeed.id, this.userDetail?.id);
    }
  }
  // add comment
  addComment(comment: any, postId: any, userId: any) {
    this._appSyncService.addComment(comment?.trim(), postId, userId).then((res: any) => {
      this.nextToken = null;
      this.loadComments();
      this.searchContent = '';
      this.editId = '';
      this.EditContent = '';
      this.hitApi = false;
      this.commentCount.emit(res.data?.addComment?.postCounts?.commentCount || 0);
      this.scrollToBottom();
    });
  }
  // update comment
  updateComment(comment: any, postId: any, commentId: any) {
    const mutation = `mutation updateComment {
    updateComment(comment: \"${comment?.trim()}\", postId: \"${postId}\",commentId:\"${commentId || ''}\") {
      ${commentRecord}
    }
  }`;

    this._commonDataService.graphqlApiCall(mutation).then((res: any) => {
      this.nextToken = null;
      this.loadComments();
      this.searchContent = '';
      this.editId = '';
      this.EditContent = '';
      this.commentCount.emit(res.data?.addComment?.postCounts?.commentCount || 0);
      // this._toastr.success('Comment updated successfully');
    });
  }
  // add comment
  deleteComment(commentId: any, postId: any) {
    this.activeDropdown = null;
    let modalRef = this._ngbModal.open(ConfirmationPopupComponent, {
      backdrop: 'static',
      keyboard: false,
      size: 'small confirmationPopup',
      centered: true,
    });
    modalRef.componentInstance.confirmationMessage = confirmationMessages.deleteComment;
    modalRef.result.then((res: any) => {
      if (res) {
        const mutation = `mutation deleteComment {
              deleteComment(commentId: \"${commentId}\", postId: \"${postId}\") {
                 ${commentRecord}
              }
            }`;

        this._commonDataService.graphqlApiCall(mutation).then((res: any) => {
          this.nextToken = null;
          this.loadComments();
          this.searchContent = '';
          this.editId = '';
          this.EditContent = '';
          this.commentCount.emit(res.data?.addComment?.postCounts?.commentCount || 0);
          this._toastr.success('Comment deleted successfully');
        });
      }
    });
  }
  ReportedComment(data: any, i: any) {
    let value = true;
    if (data.reportedBy == null) {
      return value;
    }
    data.reportedBy.map((item: any) => {
      if (item.userId == this.userDetail.id) {
        value = false;
      }
    });
    return value;
  }
  showSubmit(value: any) {
    if (value == '' || value == null || value == undefined) {
      return false;
    }
    const hasWhitespace = (value as string)?.trim().length === 0;

    return hasWhitespace ? false : true;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }
  closeDropdown(): void {
    // Close the currently active dropdown
    this.activeDropdown = null;
  }
  scrool() {
    if (this.nextToken != null && this.scroolInit == false) {
      this.scroolInit = true;

      this.activeDropdown = null;
      // this.loadComments();
      this._appSyncService.getActivities(this.DetailsFeed.id, 20, this.nextToken).then((response) => {
        this.nextToken = response.data?.getComments?.nextToken ? JSON.stringify(response.data?.getComments?.nextToken) : null;
        // this.commentList = response.data.getComments?.items || [];
        response.data.getComments?.items.map((item: any) => {
          this.commentList.push(item);
        });
        this.scroolInit = false;
        // console.group(this.nextToken);
      });
    }
  }

  scrollToBottom() {
    if (this.commentContainer) {
      const element = this.commentContainer.nativeElement;
      element.scrollTop = element.scrollHeight;
    }
  }
  userSearch(id: any) {
    this.activeDropdown = null;
    this.closeBox.emit(true);
    this._router.navigate(['/user/feed/' + id]);
  }
}
